import React from 'react'
import "./../styles/article.css";

const ExcellenceAndSuccess = () => {
    return (
        <div className="card">
            <div className="Home__container">
                <div className="article-border">
                    <div className="article-container">
                        <h1 className='article-mainheading'>Show Choir: Where Excellence and Success Harmonize</h1>

                        <p> As the show choirs gracefully grace the stage, captivating our hearts with
                            their unwavering dedication to excellence, it becomes clear that there's
                            more to these performers than their vocal and artistic prowess. With over
                            four decades of research and analysis, we have meticulously
                            documented the present and future of these young musicians. Here, we
                            unveil the remarkable highlights:</p>



                        <div className='list-with-images-right-grid list-font'>

                            <div className='ig-left'>

                                <div className='list-and-images'>
                                    <div className='listwimage-text'>
                                        <h2 className='sub-head mt-20 mb-20'>General Overview:</h2>
                                        <li>

                                            <span className="sub-head-list">Show Choir Members Are Smart: </span>

                                            Reading music, singing, and dancing
                                            not only ignite their artistic abilities
                                            but also enhance cognitive,
                                            emotional, and motor skills, laying
                                            the foundation for all-encompassing
                                            learning endeavors.
                                        </li>

                                    </div>
                                </div>

                                <img className='list-image-small-screen' src='images/article4/1.jpg' />
                                <div className='listwimage-text'>
                                    <li>

                                        <span className="sub-head-list">Advanced Literacy Skills: </span>

                                        Show
                                        Choir members showcase more
                                        extensive vocabularies and
                                        advanced reading skills compared
                                        to their peers who do not participate
                                        in music.
                                    </li>

                                </div>

                                <img className='list-image-small-screen' src='images/article4/2.jpg' />
                                <div className='listwimage-text spn2'>
                                    <li>

                                        <span className="sub-head-list">Academic Excellence: </span>

                                        These
                                        performers tend to excel in
                                        all their studies, possess heightened
                                        critical thinking skills,
                                        maintain excellent school
                                        attendance, and pursue
                                        higher education.
                                    </li>

                                </div>

                                <img className='list-image-small-screen' src='images/article4/3.jpg' />
                                <div className='listwimage-text spn2'>
                                    <li>

                                        <span className="sub-head-list">High Graduation and Attendance Rates: </span>


                                        Show choir members boast
                                        an impressive 92.2% high school
                                        graduation rate and a remarkable
                                        93.9% attendance rate, significantly
                                        surpassing their non-music peers.
                                    </li>

                                </div>

                            </div>

                            <div className='igright hide-small-screen'>

                                <img className='list-image' src='images/article4/1.jpg' />
                                <img className='list-image' src='images/article4/2.jpg' />
                                <img className='list-image' src='images/article4/3.jpg' />

                            </div>





                        </div>

                        <div className='list-font'>
                            <li><span className='sub-head-list mt-20 mb-20'>Enhanced Brain Development: </span>
                                Their musical journey contributes to
                                greater brain development and improved memory skills.
                            </li>

                            <li><span className='sub-head-list mb-20'>Higher GPAs: </span>
                                Show Choir members consistently maintain higher grade
                                point averages (GPAs) in high school.
                            </li>


                            <li><span className='sub-head-list mb-20'>Top-Performing Graduates: </span>
                                In American high schools,
                                87.6% of show choir members rank in the top ten percent of their
                                graduating class, with a staggering 94.9% of valedictorians and
                                salutatorians being show choir members.
                            </li>

                            <li><span className='sub-head-list mb-20'>Discipline and Camaraderie: </span>
                                Show Choir members are less likely to
                                have disciplinary issues, fostering camaraderie, reducing prejudice, and
                                minimizing the use of harmful sarcasm.
                            </li>


                            <li><span className='sub-head-list mb-20'>Healthy Lifestyle Choices: </span>
                                They exhibit the lowest levels of alcohol,
                                tobacco, and illicit drug use compared to any other group in society.
                            </li>






                        </div>




                        <h2 className='sub-head mt-20 mb-20'>Collegiate Path</h2>
                        <div className='list-with-images-right-grid list-font'>

                            <div className='ig-left hide-small-screen'>
                                <img className='list-image' src='images/article4/4.jpg' />
                                <img className='list-image' src='images/article4/5.jpg' />
                                <img className='list-image' src='images/article4/6.jpg' />

                            </div>
                            <div className='igright'>


                                <div className='listwimage-text'>

                                    <li>

                                        <span className="sub-head-list">College-Bound: </span>

                                        Show Choir members
                                        and music students in American high
                                        schools are at the forefront when it
                                        comes to college attendance, with a
                                        remarkable 86.4% rate.
                                    </li>

                                </div>


                                <img className='list-image-small-screen' src='images/article4/4.jpg' />
                                <div className='listwimage-text'>
                                    <li>

                                        <span className="sub-head-list">Scholarship Success: </span>
                                        They achieve an
                                        88.2% rate of scholarship funds
                                        beyond government assistance,
                                        leading to more manageable loan
                                        payback amounts and timeframes.
                                    </li>

                                </div>

                                <img className='list-image-small-screen' src='images/article4/5.jpg' />
                                <div className='listwimage-text spn2'>
                                    <li>

                                        <span className="sub-head-list">Collegiate Performing Ensembles: </span>

                                        Regardless of their desired degree
                                        path, 47.9% of Show Choir members
                                        participate in collegiate performing
                                        ensembles.
                                    </li>

                                </div>

                                <img className='list-image-small-screen' src='images/article4/6.jpg' />
                                <div className='listwimage-text'>
                                    <li>

                                        <span className="sub-head-list">Music Majors: </span>


                                        A substantial 16.8% of
                                        Show Choir members major in music
                                        and related fields.
                                    </li>

                                </div>


                                <div className='listwimage-text'>
                                    <li>

                                        <span className="sub-head-list">High Graduation Rates: </span>


                                        Show Choir
                                        members enjoy an impressive
                                        collegiate graduation rate of 88.4%, in
                                        stark contrast to the national average
                                        of 60.4% for non-music participants.
                                    </li>

                                </div>


                                <div className='listwimage-text'>
                                    <li>

                                        <span className="sub-head-list">Advanced Study: </span>
                                        A remarkable 46.4%
                                        of Show Choir members pursue
                                        advanced study through graduate
                                        programs.
                                    </li>

                                </div>

                            </div>

                        </div>

                        <div className='mt-20 mb-20 list-font'>
                            <li className='mb-20'><span className='sub-head-list'>Outstanding Exam Scores: </span>Music majors excel on the Graduate Records
                                Examinations (GRE), the Medical College Admission Test (MCAT), Law
                                School Admission Test (LSAT), and the Graduate Management Admission
                                Test (GMAT) by a remarkable 86.4% compared to non-music majors.</li>

                            <li><span className='sub-head-list'>Medical School Admission: </span>Music majors are the most likely group of
                                college graduates to gain admission to medical school.</li>
                        </div>

                        <h2 className='sub-head-list'>General Career Paths (Present High School Show Choir Members)</h2>
                        <div id='career-list' className='list-font'>

                            <div id='img-lst-flt'>
                                <img src='images/article4/7.jpg' />
                            </div>
                            <ul id='career-ul'>
                                <li>Computer Sciences and Information Services: 16.2%.</li>
                                <li>Business: 13.1%</li>
                                <li>Health Services: 10.2%</li>
                                <li>Financial Services: 9.1%</li>
                                <li>Engineering: 8.8%</li>
                                <li>Education (including Music Education): 8.7%</li>
                                <li>Biological and Biomedical Services:
                                    8.4%</li>
                                <li>Visual and Performing Arts: 8.2%</li>
                                <li>Psychology and Clergy: 4.2% </li>
                                <li>Legal Services: 2.7%</li>
                                <li>Communication and Journalism:
                                    2.5%</li>
                                <li>Travel and Leisure: 1.7%</li>
                                <li>Social Sciences and History: 1.2%</li>
                                <li>Other: 5.0%</li>

                            </ul>



                        </div>





                    </div>
                    <div className='article-ad'>
                        <a href='https://www.accoladi.com/' target='_blank'>
                            <img src='images/accoladi-add2.jpg' />
                        </a>

                    </div>

                </div>
            </div>
        </div>
    )
}

export default ExcellenceAndSuccess